const ProgressBar = ({ reference }) => {
  return (
    <div className="fixed top-16 z-[3] h-2 w-full bg-secondary-darkest">
      <div
        ref={reference}
        className="h-2 w-0 bg-gradient-to-r from-yellowgreen to-green-dark"
      ></div>
    </div>
  );
};

export default ProgressBar;
